module.exports = __webpack_public_path__ + "static/genaiz-thumbnail-28bee16f44ea7b216931cc197ffdb5b5.png";